import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { FILTER_FIELD_PRICE_LABEL_SYNC_HISTORY, SEEN_OPTIONS } from './utils'

const PriceLabelSyncHistoryFilterForm = () => {
  const { filters, setField } = useLogFilters(
    FILTER_FIELD_PRICE_LABEL_SYNC_HISTORY,
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <FilterTextInput
        label="Search"
        value={filters.search || ''}
        onApply={(value) => setField('search', value)}
        placeholder="Search barcode, store, requester..."
      />

      <FilterTextInput
        label="Store Code"
        value={filters.store || ''}
        onApply={(value) => setField('store', value)}
      />

      <FilterTextInput
        label="Barcode"
        value={filters.barcode || ''}
        onApply={(value) => setField('barcode', value)}
      />

      <FilterTextInput
        label="Emp ID"
        value={filters.empId || ''}
        onApply={(value) => setField('empId', value)}
      />

      <div className="min-w-[200px]">
        <Dropdown
          name="isSeen"
          label="Status"
          options={SEEN_OPTIONS}
          defaultValue={filters.isSeen || ''}
          setValue={(_field: string, value: string) =>
            setField('isSeen', value)
          }
        />
      </div>

      <FilterDateInput
        label="From"
        value={filters.from || ''}
        onChange={(value) => setField('from', value)}
      />

      <FilterDateInput
        label="To"
        value={filters.to || ''}
        onChange={(value) => setField('to', value)}
      />
    </div>
  )
}

export default PriceLabelSyncHistoryFilterForm
